import React from "react";
import "./Latest-projects.css";
import SimpleImageSlider from "react-simple-image-slider";


const Latestprojects = () => {
  const IMGs = [
    { url: "assets/Gardens/3.webp" },
    { url: "assets/Gardens/2.webp" },
    { url: "assets/Gardens/4.webp" },
    { url: "assets/Gardens/5.webp" },
    { url: "assets/Gardens/6.webp" },
    { url: "assets/Gardens/7.webp" },
    { url: "assets/Gardens/1.webp" },
    
  ];
  return (
    <div class="latest-project">
      {/* <h2>Neohaus نيــو هـــاوس</h2>
      <p>أكثر من وجهة سكنية؛ إنه تجسيد للتجديد، وتحية للتقدم، واحتفال ببدايات جديدة.</p>
      <img src={neohaus} alt=" neo hause project " className="latest-projects-image" />
      <p>شقق من غرفتين و وثلاث غرف نوم مساحات تبدأ من 118م2 الى 200 م2</p>
      <a href="https://neohaus.sa" className="latest-projects-button" target="_blank" rel="noopener noreferrer">زيارة المشروع</a> */}
      <h1 className="LPage-H Green ">أحدث مشاريعنا السكنية</h1>

      <div className="latest-projects">
        <div className="LPage-content">
          <h1 className="Green">نيو هاوس Neohaus</h1>
          <p className="">أكثر من وجهة سكنية؛ إنه تجسيد للتجديد، وتحية للتقدم، واحتفال ببدايات جديدة.</p>
          <div className="LPage-Slider Mobile-ONLY">
          <SimpleImageSlider
          width={350}
          height={250}
          images={IMGs}
          showNavs={true}
          navStyle={2}
          navMargin={"110"}
        />
        </div>
          <p>شقق من غرفتين وثلاث غرف نوم و مساحات تبدأ من 113م2 الى 298 م2</p>
          <a href="https://neohaus.sa" className="latest-projects-button" target="_blank" rel="noopener noreferrer">اكتشف</a>
        </div>
        <div className="LPage-Slider Desktop-ONLY">
          <SimpleImageSlider
          width={850}
          height={535}
          images={IMGs}
          // showBullets={true}
          showNavs={true}
        />
        </div>
        {/* <div className="LPage-Slider Mobile-ONLY">
          <SimpleImageSlider
          width={350}
          height={250}
          images={IMGs}
          showNavs={true}
          navStyle={2}
          navMargin={"125"}
        />
        </div> */}
      </div>
      <div className="latest-projects LP-p2">
        <div className="LPage-content">
          <h1 className="Green">نيو هاوس قاردنز</h1>
          <p className="Green">"حيث كل فجر جديد يمثل بداية جديدة"</p>
          <div className="LPage-Slider Mobile-ONLY">
          <SimpleImageSlider

          width={350}
          height={250}
          images={IMGs}
          showNavs={true}
          navStyle={2}
          navMargin={"110"}

        />
        </div>
          <p>مجمع يحتوي على 41 تاون هاوس بمساحات تصل الى 512م٢ </p>
          <button className="latest-projects-button" target="_blank" rel="noopener noreferrer">قريباً</button>
        </div>
        <div className="LPage-Slider Desktop-ONLY">
          <SimpleImageSlider
          width={850}
          height={535}
          images={IMGs}
          // showBullets={true}
          showNavs={true}
        />
        </div>
        {/* <div className="LPage-Slider Mobile-ONLY">
          <SimpleImageSlider
          width={350}
          height={250}
          images={IMGs}
          showNavs={true}
          navStyle={2}
          navMargin={"125"}

        />
        </div> */}
      </div>
      
    </div>
  );
};

export default Latestprojects;
